import { ArrowLeftOutlined } from '@ant-design/icons';
import { AuthSource } from '@framework/auth';
import { t } from '@framework/i18n';
import { IFrontLoginFormProps } from '@framework/theme/src/front/FrontLoginForm';
import { VerticalSpace } from '@framework/ui';
import { useState } from 'react';
import { PaLoginButton } from '../soap-ldap/PaLoginButton';
import { SoapLoginForm } from '../soap-ldap/SoapLoginForm';
import { FixedHeightBlock } from './FixedHeightBlock';
import { LoginBlock } from './LoginBlock';

interface ILoginBlockStepsPaUsersProps extends IFrontLoginFormProps {
  skipLoginBlock?: boolean;
}

/**
 * Form di login utenti PA amministrazione frontoffice.
 */
export function LoginBlockStepsPaUsers(props: ILoginBlockStepsPaUsersProps) {
  const { resolvePublicUrl, onLogin, skipLoginBlock = false } = props;
  const [formVisible, setFormVisible] = useState(skipLoginBlock);
  const [backButtonFocus, setBackButtonFocus] = useState(false);

  // A11Y Accessibilità per il focus pulsante back
  const handleSetVisible = (visible: boolean) => {
    setFormVisible(visible);
    setBackButtonFocus(!visible);
  };

  const description = t(
    'user.login.pa-users.description',
    'Accesso riservato al personale del Ministero della Cultura.',
  );

  return (
    <>
      {!formVisible ? (
        <LoginBlock
          before={<div>{description}</div>}
          button={
            <PaLoginButton
              role="button"
              autoFocus={backButtonFocus}
              id="pa-user-login-button"
              // aria-controls="pa-user-login-region"
              onClick={() => handleSetVisible(true)}
            />
          }
        />
      ) : (
        <div
          role="region"
          id="pa-user-login-region"
          aria-labelledby="pa-user-login-button"
          aria-expanded={formVisible}
        >
          <LoginBlock
            before={
              <div>
                {skipLoginBlock ? (
                  <div>{description}</div>
                ) : (
                  <FixedHeightBlock>
                    <b>
                      <a
                        href="#"
                        onClick={event => {
                          event.preventDefault();
                          handleSetVisible(false);
                        }}
                      >
                        <ArrowLeftOutlined aria-hidden="true" />{' '}
                        {t('user.login.pa-users.link.back', 'Indietro')}
                      </a>
                    </b>
                    <br />
                    {description}
                  </FixedHeightBlock>
                )}
                <VerticalSpace size={12} />
                <SoapLoginForm
                  source={AuthSource.FrontOffice}
                  onLogin={onLogin}
                  isFrontLogin
                />
              </div>
            }
          />
          <VerticalSpace size={12} />
        </div>
      )}
    </>
  );
}
